import { createContext, useContext } from 'react';
import type { ShopperProducts } from '@/scapi';

export interface NavigationMenuContextValue {
    categories: ShopperProducts.schemas['Category'][];
    isOpen: boolean;
    toggle: () => void;
    close: () => void;
    getElementProps: (args: {
        level: number;
        category: ShopperProducts.schemas['Category'];
        isLeaf?: boolean;
    }) => Record<string, unknown>;
    defaultListStyle: { width: string; maxWidth: string };
}

export const NavigationMenuContext = createContext<NavigationMenuContextValue | null>(null);

export function useNavigationMenu(): NavigationMenuContextValue {
    const context = useContext(NavigationMenuContext);
    if (!context) {
        throw new Error('Navigation menu components must be rendered within NavigationMenuProvider');
    }
    return context;
}
